export default __webpack_public_path__ + "static/media/lr_text.5c93e0d9.svg";